import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{marginTop: '2px'}}
    {...props}
  >
    <rect width={20} height={20} rx={10} fill="#FF4F17" />
    <path
      d="M8.24181 14.5016C8.24181 14.5016 8.21181 14.5016 8.19681 14.5016C8.11681 14.4866 8.04681 14.4316 8.01681 14.3566L7.29681 12.7066L5.64681 11.9916C5.57181 11.9566 5.51681 11.8916 5.50181 11.8066C5.48681 11.7216 5.51181 11.6416 5.57181 11.5816L6.05681 11.0966C6.21181 10.9366 6.44181 10.8666 6.66681 10.8966L7.58181 11.0416L9.15181 9.4716L5.64681 7.5516C5.57681 7.5116 5.53181 7.4466 5.52181 7.3666C5.51181 7.2866 5.53681 7.2116 5.59181 7.1566L6.08181 6.6666C6.26681 6.4816 6.54181 6.4066 6.79181 6.4716L11.0268 7.5716L12.7918 5.8066C13.1418 5.4566 13.6968 5.3966 14.0818 5.6766C14.3168 5.8516 14.4668 6.1116 14.4918 6.3966C14.5118 6.6816 14.4118 6.9666 14.2068 7.1666L12.4118 8.9616L13.5118 13.2016C13.5768 13.4616 13.5018 13.7316 13.3168 13.9166L12.8318 14.4016C12.7768 14.4566 12.6968 14.4866 12.6218 14.4716C12.5418 14.4616 12.4768 14.4116 12.4368 14.3416L10.5318 10.8466L8.96181 12.4166L9.11181 13.3266C9.15181 13.5466 9.07681 13.7816 8.91181 13.9466L8.42681 14.4266C8.38181 14.4716 8.31681 14.4966 8.25181 14.4966L8.24181 14.5016Z"
      fill="white"
    />
  </svg>
);
export default SVGComponent;
